export default {
      id: "arrow-right-usage",
      viewBox: "0 0 31 33",
      url: __webpack_public_path__ + "svg/sprite.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }